"use client";

import { useFormikContext } from "formik";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";

import { Tile } from "@ui/js/components/tiles/tile";

const INPUT_ID_AND_LABEL_HTMLFOR = "credit-score";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function CreditScore() {
  const { setFieldValue } = useFormikContext();

  const handleClick = (e: any) => {
    setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
  };

  return (
    <Fieldset legend="What is your estimated credit score?">
      <Input
        type="hidden"
        name={FIELD_NAME_SELECTOR}
        id={INPUT_ID_AND_LABEL_HTMLFOR}
      />
      <Tile label="Excellent 720-850" value="excellent" onClick={handleClick} />
      <Tile label="Good 680-719" value="good" onClick={handleClick} />
      <Tile label="Fair 640-679" value="fair" onClick={handleClick} />
      <Tile label="Poor 0 - 639" value="poor" onClick={handleClick} />
    </Fieldset>
  );
}
